// import ReactGA from "react-ga";
import { MIXPANEL_PROD_TOKEN, MIXPANEL_STG_TOKEN, ROLES, VIDEO_SESSION_PAGES as VSP } from "./constants";
import mixpanel from "mixpanel-browser";

const OPT_OUT = [];
// let colorIndex = 0;

const IS_MP_ENABLED = true;

/* Start MixPanel */
const MP_track = (event_name, properties = {}) => {
  if (IS_MP_ENABLED) {
    mixpanel.track(event_name, properties);
  }
};

const MP_StartTimedEvent = (eventName) => {
  IS_MP_ENABLED && mixpanel.time_event(eventName);
};

const MP_SetUser = (id) => {
  if (IS_MP_ENABLED && !OPT_OUT.includes(id)) {
    mixpanel.identify(id || undefined);
  }
};

const MP_SetUserProperty = (properties) => {
  if (IS_MP_ENABLED) {
    mixpanel.people.set(properties);
  }
};

const MP_SetUserPropertyOnce = (key, value) => {
  if (IS_MP_ENABLED && !OPT_OUT.includes(key, value)) {
    mixpanel.people.set_once(key, value);
  }
};

const MP_SetUserPropertyIncrement = (key) => {
  if (IS_MP_ENABLED && !OPT_OUT.includes(key)) {
    mixpanel.people.increment(key);
  }
};

const MP_SetSuperProperties = (values) => {
  if (IS_MP_ENABLED && !OPT_OUT.includes(values)) {
    mixpanel.register(values);
  }
};

const MP_Reset = () => {
  if (IS_MP_ENABLED) {
    mixpanel.reset();
  }
};

const MP_Init = () => {
  if (IS_MP_ENABLED) {
    const appToken = window.location.hostname === "clinic.poppins.co.il" ? MIXPANEL_PROD_TOKEN : MIXPANEL_STG_TOKEN;
    mixpanel.init(appToken);
    MP_Reset();
  }
};
/* End MixPanel */

// eslint-disable-next-line no-unused-vars
export const trackEvent = (eventName, properties) => {
  try {
    // const colorsList = ["Red", "Blue", "Green", "Purple", "Grey", "Pink"];
 
    // const cssLog = `font-weight: bold; font-size: 150%; text-decoration: underline; color: ${colorsList[(colorIndex += 1) % colorsList.length]}`;
    // eslint-disable-next-line no-console
    // ["true", eventName].includes(localStorage.getItem("log-mp-console")) && console.info(`%c${eventName}`, cssLog);
    // eslint-disable-next-line no-console
    // ["true", eventName].includes(localStorage.getItem("log-mp-console")) && console.table(properties);

    MP_track(eventName, properties);
  } catch (e) {
    console.error(`error in trackEvent: ${e}`);
  }
};

export const startTimedEvent = (eventName) => {
  MP_StartTimedEvent(eventName);
};

export const initAnalytics = () => {
  MP_Init();
};

export const buildAnalyticsProps = (student, treatment, selectedStudent, studentsConnectedStatus = {}) => ({
  student_id: student ? `id_${student.id}` : null,
  student_connected: student ? Object.values(studentsConnectedStatus).find(
    std => std === student,
  )?.connected : Object.values(studentsConnectedStatus).some(std => std.connected === true),
  treatment_type: treatment ? treatment.type_id : null,
  treatment_id: treatment ? treatment.id : null,
  therapist_id: treatment ? `id_${treatment.therapist}` : null,
  current_student: student && selectedStudent && selectedStudent.id === student.id,
});

export const getTrackingPropsForVideo = (args) => {
  const {
    studentsConnectedStatus = {},
    selectedStudent,
    treatmentId,
    treatmentTypeId,
    treatmentStudents,
    contentDisplay,
    isScreenShared,
    videoId,
    treatment,
    isGroup,
    currentUser,
  } = args;

  const currActivityTool = isScreenShared && contentDisplay === VSP.VIDEO ? VSP.SCREENSHARE : contentDisplay;
  const studentConnected = isGroup && selectedStudent?.id !== 0 ? !!(isGroup && selectedStudent?.connected === true) : null;
  const studentConnectedPred = studentConnected != null ? studentConnected : Object.values(studentsConnectedStatus).some(std => std.connected === true);
  const isStudent = currentUser?.role === ROLES.STUDENT.id;
  const studentId = videoId === "therapist" ? null : `id_${videoId.split("_").pop()}`;
  const correctTreatmentFinder = treatmentArr => treatmentArr?.find(t => t.treatment === treatmentId);
  const currentTreatment = treatment ? correctTreatmentFinder(treatment.treatment_students) : correctTreatmentFinder(treatmentStudents);

  return {
    tool_name: currActivityTool || null,
    treatment_id: treatmentId || treatment?.id,
    treatment_type: treatmentTypeId || treatment?.type_id,
    therapist_id: currentTreatment?.therapist?.id,
    service_id: currentTreatment?.service_id,
    protocol_id: currentTreatment?.protocol,
    objective_id: currentTreatment?.objective,
    student_id: studentId,
    student_connected: isStudent ? true : studentConnectedPred,
  };
};

export const setUser = (id) => {
  MP_SetUser(id);
};

export const setUserProperty = (properties) => {
  MP_SetUserProperty(properties);
};
export const setUserPropertyOnce = (key, value) => {
  MP_SetUserPropertyOnce(key, value);
};
export const setUserPropertyIncrement = (key) => {
  MP_SetUserPropertyIncrement(key);
};
export const setSuperProperties = (values) => {
  MP_SetSuperProperties(values);
};

export const analiticsReset = () => {
  MP_Reset();
};
